import axios, { AxiosInstance } from 'axios';

// Create a custom axios instance with authentication
const createApiClient = (): AxiosInstance => {
  const apiKey = process.env.REACT_APP_API_KEY;
  
  const client = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    }
  });

  // Add API key to all requests if it's configured
  if (apiKey) {
    client.defaults.headers.common['X-API-Key'] = apiKey;
  }

  // Add request interceptor for debugging
  client.interceptors.request.use(
    (config) => {
      console.log('API Request:', config.method?.toUpperCase(), config.url);
      return config;
    },
    (error) => {
      console.error('API Request Error:', error);
      return Promise.reject(error);
    }
  );

  // Add response interceptor for error handling
  client.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        console.error('Authentication failed: Invalid or missing API key');
      } else if (error.response?.status === 403) {
        console.error('Access forbidden: Origin not allowed');
      }
      return Promise.reject(error);
    }
  );

  return client;
};

// Export a singleton instance
export const apiClient = createApiClient();

// Export the factory function if needed
export default createApiClient;